import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { LinkUsersService } from '../../../services/link-user.service';
import { ILinkUsersResponse } from '../../../classes/http-responses';
import { UtilsService } from '../../../services/utils.service';
import { Observable, timer } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import { BaseComponent } from '../../../../globals/classes/base.component';

@Component({
	selector: 'profile-complete',
	template: require('./profile-complete.component.html'),
})
export class ProfileCompleteComponent extends BaseComponent implements OnInit {
	@Input() isRenew: boolean;
	@Output() click = new EventEmitter<void>();
	public countDown: Observable<number>;

	linkUsersResponse: ILinkUsersResponse;

	constructor(public utilsService: UtilsService) {
		super();
	}

	public get successMessage(): string {
		return !this.isRenew
			? 'H διαδικασία της εξουσιοδότησης ολοκληρώθηκε με επιτυχία'
			: 'H διαδικασία της ανανέωσης εξουσιοδότησης ολοκληρώθηκε με επιτυχία';
	}

	ngOnInit(): void {
		this.mortalize(LinkUsersService.linkUsersResponse$).subscribe((response) => {
			this.linkUsersResponse = response;
			this.initCountDown(response.autoRedirectTimeout).subscribe(
				(data) => data === 0 && this.goToProfile()
			);
		});
	}

	goToProfile(): void {
		this.click.next();
	}

	private initCountDown(count: number) {
		this.countDown = timer(0, 1000).pipe(
			map((value: number) => count - value),
			takeWhile((value: number) => value >= 0)
		);
		return this.countDown;
	}
}
